import { ReactNode } from "react";
import { Stack } from "@mui/material";

const PageWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <Stack gap={3} sx={{ width: "100%" }}>
      {children}
    </Stack>
  );
};

export default PageWrapper;
